import React, { Fragment } from "react";
import {
  Table,
  Button,
  ButtonGroup,
  Row,
  Card,
  CardBody,
  CardTitle
} from "reactstrap";

import IntlMessages from "Util/IntlMessages";

import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";

function ButtonsUi() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.buttons" />}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12">
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.reactify" />
                </CardTitle>
                <Table borderless>
                  <thead>
                    <tr>
                      <th>Buttons</th>
                      <th>className=""</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <Button color="light" className="mb-2">
                          <IntlMessages id="button.light" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="light"</code>
                      </td>
                      <td>Button with light color</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button color="primary" className="mb-2">
                          <IntlMessages id="button.primary" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="primary"</code>
                      </td>
                      <td>Default Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button color="secondary" className="mb-2">
                          <IntlMessages id="button.secondary" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="secondary"</code>
                      </td>
                      <td>Secondary Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button color="info" className="mb-2">
                          <IntlMessages id="button.info" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="info"</code>
                      </td>
                      <td>Info Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button color="danger" className="mb-2">
                          <IntlMessages id="button.danger" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="danger"</code>
                      </td>
                      <td>Danger Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button color="warning" className="mb-2">
                          <IntlMessages id="button.warning" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="warning"</code>
                      </td>
                      <td>Warning Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button color="dark" className="mb-2">
                          <IntlMessages id="button.dark" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="dark"</code>
                      </td>
                      <td>Dark Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-orange mb-2">
                          <IntlMessages id="button.orange" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-orange"</code>
                      </td>
                      <td>Orange Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-turquoise mb-2">
                          <IntlMessages id="button.turquoise" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-turquoise"</code>
                      </td>
                      <td>Turquoise Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-green mb-2">
                          <IntlMessages id="button.green" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-green"</code>
                      </td>
                      <td>Green Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-yellow mb-2">
                          <IntlMessages id="button.yellow" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-yellow"</code>
                      </td>
                      <td>Yellow Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-purple mb-2">
                          <IntlMessages id="button.purple" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-purple"</code>
                      </td>
                      <td>Purple Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-aqua mb-2">
                          <IntlMessages id="button.aqua" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-aqua"</code>
                      </td>
                      <td>Aqua Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-brown mb-2">
                          <IntlMessages id="button.brown" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-brown"</code>
                      </td>
                      <td>Brown Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-light-green mb-2">
                          <IntlMessages id="button.light-green" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-light-green"</code>
                      </td>
                      <td>Light Green</td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>

            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.outline" />
                </CardTitle>
                <Table borderless>
                  <thead>
                    <tr>
                      <th>Buttons</th>
                      <th>className=""</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <Button outline color="primary" className="mb-2">
                          <IntlMessages id="button.primary" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="primary" outline</code>
                      </td>
                      <td>Primary outline button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button outline color="secondary" className="mb-2">
                          <IntlMessages id="button.secondary" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="secondary" outline</code>
                      </td>
                      <td>Secondary Outline Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button outline color="success" className="mb-2">
                          <IntlMessages id="button.success" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="success" outline</code>
                      </td>
                      <td>Secondary Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button outline color="info" className="mb-2">
                          <IntlMessages id="button.info" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="info" outline</code>
                      </td>
                      <td>outine Info Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button outline color="danger" className="mb-2">
                          <IntlMessages id="button.danger" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="danger" outline</code>
                      </td>
                      <td>Outline Danger Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button outline color="warning" className="mb-2">
                          <IntlMessages id="button.warning" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="warning" outline</code>
                      </td>
                      <td>Outline Warning Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button outline color="dark" className="mb-2">
                          <IntlMessages id="button.dark" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>color="dark" outline</code>
                      </td>
                      <td>Outline Dark Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-outline-orange mb-2">
                          <IntlMessages id="button.orange" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-outline-orange"</code>
                      </td>
                      <td>Outline Orange Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-outline-turquoise mb-2">
                          <IntlMessages id="button.turquoise" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-outline-turquoise"</code>
                      </td>
                      <td>Outline Turquoise Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-outline-green mb-2">
                          <IntlMessages id="button.green" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-outline-green"</code>
                      </td>
                      <td>Outline Green Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-outline-yellow mb-2">
                          <IntlMessages id="button.yellow" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-outline-yellow"</code>
                      </td>
                      <td>Outline Yellow Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-outline-purple mb-2">
                          <IntlMessages id="button.purple" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-outline-purple"</code>
                      </td>
                      <td>Outline Purple Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-outline-aqua mb-2">
                          <IntlMessages id="button.aqua" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-outline-aqua"</code>
                      </td>
                      <td>Outline Aqua Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-outline-brown mb-2">
                          <IntlMessages id="button.brown" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-outline-brown"</code>
                      </td>
                      <td>Outline Brown Button</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button className="btn btn-outline-light-green mb-2">
                          <IntlMessages id="button.light-green" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code>className="btn btn-outline-light-green"</code>
                      </td>
                      <td>Outline Light Green</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Button outline color="light" className="mb-2">
                          <IntlMessages id="button.light" />
                        </Button>{" "}
                      </th>
                      <td>
                        <code> outline color="light"</code>
                      </td>
                      <td>Outline Light</td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>

            {/*  Buttons with icons */}
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.with-icons" />
                </CardTitle>
                <Row>
                  <Button color="light" className="mb-2 mr-2">
                    <span className="fa fa-cloud mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button color="primary" className="mb-2 mr-2">
                    <span className="far fa-bell mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button color="secondary" className="mb-2 mr-2">
                    <span className="far fa-envelope mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button color="info" className="mb-2 mr-2">
                    <span className="fa fa-download mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button color="danger" className="mb-2 mr-2">
                    <span className="far fa-clock mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button color="warning" className="mb-2 mr-2">
                    <span className="far fa-images mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button color="dark" className="mb-2 mr-2">
                    <span className="fa fa-copy mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-orange mb-2 mr-2">
                    <span className="fa fa-cloud mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-turquoise mb-2 mr-2">
                    <span className="far fa-bell mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-green mb-2 mr-2">
                    <span className="far fa-envelope mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-yellow mb-2 mr-2">
                    <span className="fa fa-download mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-purple mb-2 mr-2">
                    <span className="far fa-clock mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-aqua mb-2 mr-2">
                    <span className="far fa-images mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-brown mb-2 mr-2">
                    <span className="fa fa-copy mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-dark-blue mb-2 mr-2">
                    <span className="far fa-images mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                  <Button className="btn btn-light-green mb-2 mr-2">
                    <span className="fa fa-copy mr-1" />
                    <IntlMessages id="icon.button" />
                  </Button>
                </Row>
                {/*  Only Icons */}
                <CardTitle className="mt-3">
                  <IntlMessages id="button.with-icons" />
                </CardTitle>
                <Row>
                  <Button color="light" className="mb-2 mr-2">
                    <span className="fa fa-cloud" />
                  </Button>
                  <Button color="primary" className="mb-2 mr-2">
                    <span className="far fa-bell" />
                  </Button>
                  <Button color="secondary" className="mb-2 mr-2">
                    <span className="far fa-envelope" />
                  </Button>
                  <Button color="info" className="mb-2 mr-2">
                    <span className="fa fa-download" />
                  </Button>
                  <Button color="danger" className="mb-2 mr-2">
                    <span className="far fa-clock" />
                  </Button>
                  <Button color="warning" className="mb-2 mr-2">
                    <span className="far fa-images" />
                  </Button>
                  <Button color="dark" className="mb-2 mr-2">
                    <span className="fa fa-copy" />
                  </Button>
                  <Button className="btn btn-orange mb-2 mr-2">
                    <span className="fa fa-cloud" />
                  </Button>
                  <Button className="btn btn-turquoise mb-2 mr-2">
                    <span className="far fa-bell" />
                  </Button>
                  <Button className="btn btn-green mb-2 mr-2">
                    <span className="far fa-envelope" />
                  </Button>
                  <Button className="btn btn-yellow mb-2 mr-2">
                    <span className="fa fa-download" />
                  </Button>
                  <Button className="btn btn-purple mb-2 mr-2">
                    <span className="far fa-clock" />
                  </Button>
                  <Button className="btn btn-aqua mb-2 mr-2">
                    <span className="far fa-images" />
                  </Button>
                  <Button className="btn btn-brown mb-2 mr-2">
                    <span className="fa fa-copy" />
                  </Button>
                  <Button className="btn btn-dark-blue mb-2 mr-2">
                    <span className="far fa-images" />
                  </Button>
                  <Button className="btn btn-light-green mb-2 mr-2">
                    <span className="fa fa-copy" />
                  </Button>
                </Row>
              </CardBody>
            </Card>

            {/* Buttons with icons */}

            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.sizes" />
                </CardTitle>
                <div className="mb-4">
                  <h6 className="mb-2">
                    <IntlMessages id="button.large-button" />
                  </h6>
                  <Row>
                    <Colxx lg="6">
                      <p>
                        Large Buttons layouts please use{" "}
                        <code>color="info" size="lg"</code> for following button
                      </p>
                      <Button color="info" size="lg" className="mb-2 mr-2">
                        <IntlMessages id="button.large-button" />
                      </Button>{" "}
                      <Button size="lg" className="btn btn-orange mb-2 mr-2">
                        <IntlMessages id="button.large-button" />
                      </Button>
                      <Button color="primary" size="lg" className="mb-2 mr-2">
                        <IntlMessages id="button.large-button" />
                      </Button>{" "}
                      <p>
                        Large Buttons layouts please use{" "}
                        <code>className="btn btn-yellow" size="lg"</code> for
                        following button
                      </p>
                      <Button size="lg" className="btn btn-yellow mb-2">
                        <IntlMessages id="button.large-button" />
                      </Button>
                      <p>
                        Default Buttons layouts please use{" "}
                        <code>className="btn btn-purple"</code> for following
                        button
                      </p>
                      <Button className="btn btn-purple mb-2">
                        <IntlMessages id="button.regular-button" />
                      </Button>
                      <p>
                        Smaller Buttons layouts please use{" "}
                        <code>size="sm" className="btn btn-aqua"</code> for
                        following button
                      </p>
                      <Button size="sm" className="btn btn-aqua mb-2">
                        <IntlMessages id="button.small-button" />
                      </Button>
                      <p>
                        For this Button layouts please use{" "}
                        <code>size="xs" color="dark"</code> for following button
                      </p>
                      <Button size="xs" color="dark" className=" mb-2">
                        <IntlMessages id="button.very-small-button" />
                      </Button>
                    </Colxx>
                    <Colxx lg="6">
                      <p>
                        Large Buttons layouts please use{" "}
                        <code>color="primary" block </code> for following button
                      </p>
                      <Button color="primary" block className="mb-2">
                        <IntlMessages id="button.block-button" />
                      </Button>{" "}
                      <Button color="secondary" block className="mb-2">
                        <IntlMessages id="button.block-button" />
                      </Button>
                      <p>
                        Large Buttons layouts please use{" "}
                        <code>block className="btn btn-yellow"</code> for
                        following button
                      </p>
                      <Button block className="btn btn-yellow mb-2">
                        <IntlMessages id="button.block-button" />
                      </Button>{" "}
                      <Button block className="btn btn-orange mb-2">
                        <IntlMessages id="button.block-button" />
                      </Button>
                      <p>
                        Disabled Buttons layouts please use{" "}
                        <code>color="primary" disabled</code> for following
                        button
                      </p>
                      <Button color="primary" disabled>
                        <IntlMessages id="button.disabled" />
                      </Button>
                      <p className="mt-2">Button Group</p>
                      <ButtonGroup className="mb-2">
                        <Button color="primary">1</Button>
                        <Button color="primary">2</Button>
                        <Button color="primary">3</Button>
                      </ButtonGroup>
                    </Colxx>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
}

export default ButtonsUi;
